import React,{useEffect,useState} from "react";
import ReviewersCard from "./card";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector } from "react-redux";

const ReviewersGrid = ({ reviewers, isSlider }) => {
  const {sessions:sdata}=useSelector(state=>state.auth);
  const [sessions,setSessions]=useState([]);
  useEffect(()=>{
    const unsubscribe=async()=> {
        let cusers=[];
        await sdata?.forEach(async(doc) => {
          let docs=doc;
          if(docs && ((docs?.status==='completed') || (docs?.status==='incomplete'))){
            cusers.push({...docs});
            setSessions(cusers);
          }
        });
      }
     unsubscribe(); 
  }, [sdata]);
 
  return (
    <>
      {isSlider?<Swiper
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          spaceBetween={0}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
          }}
        pagination={{ clickable: true }}
        modules={[Pagination, Autoplay, Navigation]}
          className="testimonial_slider"
        >
          {reviewers?.map((reviewer, idx) =><SwiperSlide key={reviewer._id || reviewer.id}>
            <ReviewersCard idx={reviewer._id || reviewer.id} sessions={sessions} reviewer={reviewer} isSlider={isSlider}/>
          </SwiperSlide>)}
        </Swiper>
        :<>
         {reviewers?.map((reviewer, idx) =><ReviewersCard key={reviewer._id || reviewer.id} idx={reviewer._id || reviewer.id} sessions={sessions} reviewer={reviewer} isSlider={isSlider}/>)}
        </>}
    </>
  );
};

export default ReviewersGrid;
